import React from "react";

import { LABELLING } from "../../config/labelling";
import { resolveProductPresentationLabelling } from "../../utils/productPresentation/labelling";

const LOGO_SIZE_CLASS_NAMES = Object.freeze({
  auth: Object.freeze({
    default: "h-32 w-auto",
    purpleDx: "h-auto w-auto max-w-full max-h-20 md:max-h-24",
  }),
  landing: Object.freeze({
    default: "h-32 md:h-52 w-auto",
    purpleDx: "h-auto w-auto max-w-full max-h-24 md:max-h-36",
  }),
});

function getLogoSizeClassName(sizeVariant, logoAsset) {
  if (!sizeVariant) {
    return null;
  }

  const variantClassNames = LOGO_SIZE_CLASS_NAMES[sizeVariant];
  if (!variantClassNames) {
    return null;
  }

  return logoAsset?.startsWith("purpledx")
    ? variantClassNames.purpleDx
    : variantClassNames.default;
}

export default function BrandLogo({
  alt = "pDx logo",
  loading = "lazy",
  sizeVariant = null,
  className = "",
  ...props
}) {
  const { logoAsset } = resolveProductPresentationLabelling(null, {
    fallbackProfileId: LABELLING.PRODUCT_PRESENTATION_PROFILE_ID,
    fallbackAppName: LABELLING.APP_NAME,
  });
  const resolvedClassName = [
    getLogoSizeClassName(sizeVariant, logoAsset),
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <img
      src={`/${logoAsset}`}
      alt={alt}
      loading={loading}
      className={resolvedClassName || undefined}
      {...props}
    />
  );
}
